const StorageKey = {
    LONGIN_TYPE: "login_type",
    BITKUB_NEXT_AUTH: "bitkub_next_auth",
    BITKUB_NEXT_USER_INFO: "bitkub_next_user_info",
    HIDE_KUB_WALLET_WARNING: "hide_kub_wallet_warning"
}

export default StorageKey;
